import { render, staticRenderFns } from "./PlainCards.vue?vue&type=template&id=7c024c55&"
import script from "./PlainCards.vue?vue&type=script&lang=js&"
export * from "./PlainCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports